import React, { useState } from "react";
import { ArrowRight } from "react-bootstrap-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/GreatLearning.css";
import CallbackRequestPopup from "./CallbackRequestPopup";

const GreatLearning = () => {
  const [showCallbackPopup, setShowCallbackPopup] = useState(false);

  const openCallbackPopup = () => {
    setShowCallbackPopup(true);
  };

  const closeCallbackPopup = () => {
    setShowCallbackPopup(false);
  };

  return (
    <>
      <div className="great-learning-container">
        <div className="container">
          <h2 className="section-title text-center mb-5">
            Why hire from CLIF AI
          </h2>

          <div className="row align-items-center mb-5">
            <div className="col-lg-6">
              <div className="image-wrapper">
                <div className="image-container">
                  <img
                    src="../../../images/recruiters/group-2.jpg"
                    alt="Candidates in a training session"
                    className="features-image"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="content-block">
                <h3 className="feature-title">
                  Industry-Ready Talent – Hire candidates with verified skills,
                  trained through industry-relevant programs.
                </h3>
                <p className="feature-text">
                  Skill & Certification Verification – Access assessments and
                  certification details to evaluate candidate expertise.
                </p>
                <a href="/recruiterslogin">
                  <button className="btn great-learning-btn try-free-btn btn-primary">
                    Get Started Now <ArrowRight className="ms-2" />
                  </button>
                </a>
              </div>
            </div>
          </div>

          <div className="row align-items-center mb-5 flex-column-reverse flex-lg-row">
            <div className="col-lg-6">
              <div className="content-block">
                <h3 className="feature-title">
                  Discover a Skilled Talent Pool – Unleash Your Team’s Potential
                  with a Skilled Talent Pool{" "}
                </h3>
                <p className="feature-text">
                  Our candidates specialize in technology, data, management, and
                  more, with diverse expertise across industries.
                </p>
                <a href="/recruiterslogin">
                  <button className="btn great-learning-btn try-free-btn btn-primary">
                    Browse our talent directory <ArrowRight className="ms-2" />
                  </button>
                </a>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="image-wrapper">
                <div className="image-container">
                  <img
                    src="../../../images/recruiters/group-1.jpg"
                    alt="Group of trained professionals"
                    className="features-image"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row align-items-center mb-5">
            <div className="col-lg-6">
              <div className="image-wrapper">
                <div className="image-container">
                  <img
                    src="../../../images/recruiters/group-6.jpg"
                    alt="Hiring process illustration"
                    className="features-image"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="content-block">
                <h3 className="feature-title">
                  Customized Hiring Solutions to Meet Your Needs
                </h3>

                <div className="hiring-mode">
                  <h4>Job Board –</h4>
                  <p>
                    Post your job openings and attract a highly motivated,
                    trained talent pool.
                  </p>
                </div>

                <div className="hiring-mode">
                  <h4>CLIF AI Career Fair –</h4>
                  <p>
                    Meet top talent at our CLIF AI Career Fairs in metro cities.
                  </p>
                </div>

                <div className="hiring-mode">
                  <h4>Exclusive Hiring Drives –</h4>
                  <p>
                    Run recruitment campaigns tailored for your organization.
                  </p>
                </div>

                <button
                  className="btn btn-outline-primary"
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#006600";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "white";
                    e.target.style.color = "#6600CC";
                  }}
                  onClick={openCallbackPopup}
                >
                  Schedule a callback <ArrowRight className="ms-2" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CallbackRequestPopup
        isOpen={showCallbackPopup}
        onClose={closeCallbackPopup}
      />
    </>
  );
};

export default GreatLearning;
